<template>
  <div class="banner-accept">
    <div class="banner-accept__image-container">
      <smd-profile-img :image="odLatestBooking.profile_url"
                       class="doctor"/>
      <smd-profile-img-placeholder
        :text="patientNamePlaceHolder"
        size="xs"
        class="patient" />
    </div>

    <div class="banner-accept__text-container">
      <p class="Title1">Consultation with {{ odLatestBooking.doctorname }}</p>
      <p class="Title3 gray-400">Today at {{ consultationTime }}</p>
    </div>

    <smd-btn class="btn004 btn004--unselected banner-accept__btn"
             @click.stop.prevent="$emit('hide-banner')">
      Hide
    </smd-btn>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import Ico017 from '@/assets/icons/ico017.svg';
  import {GETTER_ONDEMAND_LATEST_BOOKING} from '@/store/types';

  export default {
    name: 'banner-accept',
    computed: {
      ...mapGetters({
        odLatestBooking: GETTER_ONDEMAND_LATEST_BOOKING,
      }),
      patientNamePlaceHolder() {
        return `${this.odLatestBooking.firstname} ${this.odLatestBooking.lastname}`;
      },
      consultationTime() {
        return moment(this.odLatestBooking.responsedate).format('h:mm a');
      },
    },
    Ico017,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .banner-accept {
    @include make-grid-cols(50px 1fr min-content, 16px, align-items-center);
    background-image: linear-gradient(
      120deg,
      transparent 0%,
      transparent 33%,
      transparent 67%,
      #10b26e 160%
    );

    &__image-container {
      position: relative;

      > * {
        border: 1px solid color(gray-100);
      }

      :first-child {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      :last-child {
        position: absolute;
        right: -5px;
      }

      .patient {
        font-size: 15px;
      }
    }

    &__btn.btn004 {
      border-color: color(green);
      color: color(green);
    }
  }
</style>
